export default "__VITE_ASSET__BHvOQQ5U__"